/* =========================================================================
   COMPONENT: ATELIER GLOBAL DIALOG API
   ========================================================================= */
window.AtelierDialog = (function() {
  let currentConfirmHandler = null;
  let currentCancelHandler = null;

  function open({ title, text, confirmText = 'Confirm', cancelText = 'Cancel' }) {
    return new Promise((resolve) => {
      const overlay = document.getElementById('AtelierDialogOverlay');
      const titleEl = document.getElementById('AtelierDialogTitle');
      const textEl = document.getElementById('AtelierDialogText');
      const confirmBtn = document.getElementById('AtelierDialogConfirm');
      const cancelBtn = document.getElementById('AtelierDialogCancel');

      // Fallback if the DOM elements are missing
      if (!overlay || !confirmBtn || !cancelBtn) {
        console.warn('Atelier Dialog DOM missing. Falling back to native browser confirm.');
        resolve(window.confirm(text));
        return;
      }

      // 1. Populate the dynamic content
      if (titleEl) titleEl.textContent = title;
      if (textEl) textEl.textContent = text;
      confirmBtn.textContent = confirmText;
      cancelBtn.textContent = cancelText;

      // 2. Clean up any lingering event listeners
      if (currentConfirmHandler) confirmBtn.removeEventListener('click', currentConfirmHandler);
      if (currentCancelHandler) cancelBtn.removeEventListener('click', currentCancelHandler);

      // 3. Define the cleanup and close function
      const closeDialog = () => {
        overlay.classList.remove('is-visible');
        document.body.classList.remove('overflow-hidden'); // Optional: removes background scroll lock
      };

      // 4. Create the fresh handlers
      currentConfirmHandler = () => { closeDialog(); resolve(true); };
      currentCancelHandler = () => { closeDialog(); resolve(false); };

      confirmBtn.addEventListener('click', currentConfirmHandler);
      cancelBtn.addEventListener('click', currentCancelHandler);

      // 5. Open the modal
      overlay.classList.add('is-visible');
      document.body.classList.add('overflow-hidden'); // Optional: locks background scroll
    });
  }

  return { open };
})();